/**
 * Да, блять, это опять ебаный реактивный синглтон!
 */
import { reactive } from 'vue';

export default class {
  static instance;
  _formObj;
  errors = {};
  errorsNalog = reactive({});
  errorsGetter = reactive({});
  errorsBetween = reactive({});
  canSubmit = true;
  notNeedInn;

  constructor(formObj, notNeedInn) {
    //console.log(notNeedInn);
    if(this.constructor.instance) return this.constructor.instance;
    this.constructor.setInstance(this);
    this.constructor.instance._formObj = formObj;
    this.constructor.instance.notNeedInn = notNeedInn;
    //this.constructor.instance.check();
    return this.constructor.instance;
  }
  check() {
    return this.constructor.instance.getErrors();
  }
  fieldIsEmpty(name) {
    return name in this.constructor.instance._formObj === false || !this.constructor.instance._formObj[name];
  }
  checkFieldsArray(arr) {
    const instance = this.constructor.instance;
    instance.errors = {};

    arr.map(field => {
      instance.errors[field] = instance.fieldIsEmpty(field);
    });
    return instance.errors;
  }
  getErrors() {
    const instance = this.constructor.instance;

    const arrFields = [
      'fio',
      'phone',
      'inn',
      'birth',
      'mail',
      'document',
      'vedomstvo',
      //
      'year',
      'whoclient',
      //
      'fio2',
      'birth2',
      'document2',
      'vedomstvo2',
      //
      'soglasie',
      'method'
    ];

    if(instance._formObj.document == 'Паспорт') {
      arrFields.push('seria');
      arrFields.push('number');
      arrFields.push('date');
    }

    if(instance._formObj.document2 == 'Паспорт') {
      arrFields.push('seria2');
      arrFields.push('number2');
      arrFields.push('date2');
    }
    if(instance._formObj.document2 == 'Свидетельство о рождении') {
      arrFields.push('svseria');
      arrFields.push('svnumber');
      arrFields.push('svdate');
    }

    if(instance._formObj.method == 'На электронную почту') arrFields.push('mailmethod');


    if(instance._formObj.client == 'Ребенку') {
     // arrFields.push('whoclent');
    }

    if(!instance.notNeedInn) arrFields.push('inn2');

    const obj = instance.checkFieldsArray(arrFields);

    obj.count = 0;
    for(let key in obj) {
      if(key !== 'count' && obj[key]) {
        obj.count ++;
      }
    }
    return obj;
  }

  static setInstance(instance) {
    this.instance = reactive(instance);
  }
}